"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeaderStyle = exports.getCellStyle = exports.getTableUiSchema = exports.getTableActions = exports.getCellValidationInfo = exports.createTableUids = exports.overrideDefaultsAndFilterRows = exports.getValueBasedOnState = exports.getTableFormData = exports.removeRowFromTable = exports.addRowToTable = exports.addRowsToTable = exports.overrideCellValue = exports.createInitialRows = exports.getInitialTableFormData = exports.calculateColumnWidth = exports.isTableInState = exports.overrideTableDefaultsWithChanges = exports.getTableHelpers = exports.getTableComponentSchema = void 0;
var Tables_1 = require("@microchip/melody-automodule-interface/lib/src/Tables");
var Arrays_1 = require("@microchip/scf-device/lib/util/Arrays");
var UidMapBuilder_1 = require("./UidMapBuilder");
function getTableComponentSchema(component, viewModel) {
    var _a, _b, _c, _d;
    var tableColumns = {};
    for (var columnsKey in component.columns) {
        var rjsfType = void 0;
        if (component.columns[columnsKey].type === "ComboBox") {
            var colBox = component.columns[columnsKey];
            rjsfType = "string";
            tableColumns[columnsKey] = {
                type: rjsfType,
                title: colBox.title,
                default: getDefaultValue(viewModel.overrideDefaultValues, colBox, columnsKey, component.name),
                enum: getComboOptions(viewModel.overrideTableOptions, colBox, columnsKey, component.name),
            };
        }
        else {
            rjsfType = (_a = component === null || component === void 0 ? void 0 : component.columns[columnsKey]) === null || _a === void 0 ? void 0 : _a.type;
            tableColumns[columnsKey] = {
                type: rjsfType,
                title: component.columns[columnsKey].title,
                default: component.columns[columnsKey].defaultValue,
            };
        }
    }
    return {
        type: "array",
        title: (_d = (_c = (_b = viewModel.getDerivedFunction).overrideTitle) === null || _c === void 0 ? void 0 : _c.call(_b, component.name)) !== null && _d !== void 0 ? _d : component.description,
        items: {
            type: "object",
            properties: __assign({}, tableColumns),
        },
    };
}
exports.getTableComponentSchema = getTableComponentSchema;
var getTableHelpers = function () {
    return {
        addRowToTable: addRowToTable,
        addRowsToTable: addRowsToTable,
        calculateColumnWidth: calculateColumnWidth,
        createInitialRows: createInitialRows,
        createTableUids: createTableUids,
        getCellStyle: getCellStyle,
        getCellValidationInfo: getCellValidationInfo,
        getHeaderStyle: getHeaderStyle,
        getInitialTableFormData: getInitialTableFormData,
        getTableActions: getTableActions,
        getTableFormData: getTableFormData,
        getTableUiSchema: getTableUiSchema,
        getValueBasedOnState: getValueBasedOnState,
        isTableInState: isTableInState,
        overrideCellValue: overrideCellValue,
        overrideDefaultsAndFilterRows: overrideDefaultsAndFilterRows,
        overrideTableDefaultsWithChanges: overrideTableDefaultsWithChanges,
        removeRowFromTable: removeRowFromTable,
        createUidMapBuilder: function () { return new UidMapBuilder_1.UidMapBuilder(); },
    };
};
exports.getTableHelpers = getTableHelpers;
function overrideTableDefaultsWithChanges(rowChanged, initialFormData, uidMap) {
    var value = __spreadArray([], initialFormData, true);
    if (Array.isArray(rowChanged)) {
        rowChanged.forEach(function (changedRow) {
            var changedUid = changedRow.uid;
            var rowChangeNum = uidMap[changedUid];
            value[rowChangeNum] = __assign(__assign({}, value[rowChangeNum]), changedRow);
        });
    }
    return value;
}
exports.overrideTableDefaultsWithChanges = overrideTableDefaultsWithChanges;
function isTableInState(tabState, component) {
    return (tabState && tabState[component.group] && tabState[component.group][component.name]);
}
exports.isTableInState = isTableInState;
function calculateColumnWidth(columns) {
    if (!columns) {
        return {};
    }
    var runningWidth = 0;
    var booleanFields = 0;
    var columnWidths = {};
    for (var columnName in columns) {
        if (columns[columnName].type === "boolean") {
            var width = 8;
            booleanFields++;
            columnWidths[columnName] = width;
            runningWidth += width;
        }
    }
    for (var columnName in columns) {
        if (columns[columnName].type !== "boolean") {
            var width = (100 - runningWidth) / (Object.keys(columns).length - booleanFields);
            columnWidths[columnName] = width;
        }
    }
    return columnWidths;
}
exports.calculateColumnWidth = calculateColumnWidth;
function getInitialTableFormData(table, columnNames, model) {
    var value = [];
    var tableFormData = {};
    columnNames.forEach(function (columnName) {
        if (!tableFormData[columnName]) {
            tableFormData[columnName] = getDefaultValue(model.getDerivedFunctions().overrideTableDefaultValues, table.columns[columnName], columnName, table.name);
        }
    });
    if (!(table === null || table === void 0 ? void 0 : table.rowData)) {
        value = createInitialRows(table, tableFormData);
    }
    else {
        var rowId_1 = 0;
        table === null || table === void 0 ? void 0 : table.rowData.forEach(function (row) {
            var rowDataCols = Object.keys(row);
            columnNames.forEach(function (colName) {
                var _a;
                if (rowDataCols.indexOf(colName) === -1) {
                    row = __assign(__assign({}, row), (_a = {}, _a[colName] = tableFormData[colName], _a.uid = createRowUid(Tables_1.RowPrefix.Default, rowId_1), _a));
                }
            });
            value.push(__assign(__assign({}, row), { uid: createRowUid(Tables_1.RowPrefix.Default, rowId_1), rowId: rowId_1 }));
            rowId_1++;
        });
    }
    return value;
}
exports.getInitialTableFormData = getInitialTableFormData;
function createInitialRows(table, tableFormData) {
    var _a;
    if (tableFormData === void 0) { tableFormData = {}; }
    var value = [];
    var initialRows = (_a = table === null || table === void 0 ? void 0 : table.defaultRowNum) !== null && _a !== void 0 ? _a : 1;
    for (var i = 0; i < initialRows; i++) {
        value.push(__assign(__assign({}, tableFormData), { rowId: i, uid: createRowUid(Tables_1.RowPrefix.Default, i) }));
    }
    return value;
}
exports.createInitialRows = createInitialRows;
function overrideCellValue(tableData, cell) {
    var modifiedTableData = __spreadArray([], tableData, true);
    modifiedTableData[cell.rowId][cell.columnName] = cell.value;
    return modifiedTableData;
}
exports.overrideCellValue = overrideCellValue;
function addRowsToTable(tableData, columns, newRow, numberOfRows) {
    if (numberOfRows <= 0) {
        return tableData;
    }
    var value = addRowToTable(tableData, columns, __assign(__assign({}, newRow), { uid: Tables_1.RowPrefix.Dynamic + (numberOfRows - 1) }));
    return addRowsToTable(value, columns, newRow, numberOfRows - 1);
}
exports.addRowsToTable = addRowsToTable;
function addRowToTable(tableData, columns, newRow) {
    var _a;
    var columnNames = Object.keys(columns);
    var newRowCols = Object.keys(newRow);
    var newRowId = newRow.rowId;
    var filteredTableTemp = [];
    if (tableData.length === 0) {
        filteredTableTemp.push(newRow);
        return filteredTableTemp;
    }
    if (newRowId != null) {
        columnNames.forEach(function (colName) {
            var _a;
            var _b, _c;
            var defaultColumnWidth = calculateColumnWidth(columns);
            if (newRowCols.indexOf(colName) === -1) {
                newRow = __assign(__assign({}, newRow), (_a = {}, _a[colName] = (_c = (_b = columns[colName].defaultValue) === null || _b === void 0 ? void 0 : _b["value"]) !== null && _c !== void 0 ? _c : columns[colName].defaultValue, _a.columnWidth = columns[colName].columnWidth
                    ? columns[colName].columnWidth + "%"
                    : defaultColumnWidth[colName] + "%", _a));
            }
        });
        var tableFirstHalf = tableData.slice(0, newRowId);
        var tableSecondHalf = tableData.slice(newRowId);
        for (var i = 0; i < tableSecondHalf.length; i++) {
            var currentRowId = tableSecondHalf[i].rowId;
            tableSecondHalf[i] = __assign(__assign({}, tableSecondHalf[i]), { rowId: currentRowId + 1 });
            var actions = (_a = tableSecondHalf[i]) === null || _a === void 0 ? void 0 : _a.actions;
            if (actions) {
                tableSecondHalf[i]["actions"] = updateActionsRowId(actions, currentRowId + 1);
            }
        }
        tableFirstHalf.push(newRow);
        filteredTableTemp = __spreadArray(__spreadArray([], tableFirstHalf, true), tableSecondHalf, true);
        return filteredTableTemp;
    }
    return tableData;
}
exports.addRowToTable = addRowToTable;
function removeRowFromTable(tableData, rowId) {
    var _a;
    var tableRemoved = tableData.filter(function (row) { return row.rowId !== rowId; });
    for (var i = 0; i < tableRemoved.length; i++) {
        tableRemoved[i].rowId = i;
        var actions = (_a = tableRemoved[i]) === null || _a === void 0 ? void 0 : _a.actions;
        if (actions) {
            tableRemoved[i]["actions"] = updateActionsRowId(actions, i);
        }
    }
    return tableRemoved;
}
exports.removeRowFromTable = removeRowFromTable;
function getTableFormData(model, table, tab) {
    var _a;
    return ((_a = model.getDerivedFunction(table.name, table, model, tab)) !== null && _a !== void 0 ? _a : getValueBasedOnState(table, model, tab));
}
exports.getTableFormData = getTableFormData;
function getValueBasedOnState(table, model, tab) {
    var columnNames = Object.keys(table.columns);
    var modelState = model.getState();
    var tabState = modelState ? modelState[tab] : undefined;
    var initialFormData = getInitialTableFormData(table, columnNames, model);
    if (!isTableInState(tabState, table)) {
        return initialFormData;
    }
    else {
        var rowChanged = tabState[table.group][table.name];
        var tableUids = createTableUids(table, tab, model, rowChanged);
        return overrideDefaultsAndFilterRows(rowChanged, initialFormData, table.columns, tableUids, table, tab);
    }
}
exports.getValueBasedOnState = getValueBasedOnState;
function overrideDefaultsAndFilterRows(rowChanged, initialFormData, columns, tableUids, component, tab) {
    var modifiedForData = __spreadArray([], initialFormData, true);
    var keys = Object.keys(tableUids);
    rowChanged = rowChanged.filter(function (row) { return row != null; });
    rowChanged.forEach(function (row) {
        if (row.uid.indexOf(Tables_1.RowPrefix.Dynamic) > -1) {
            modifiedForData.push(row);
        }
    });
    var filteredModifed = [];
    keys.forEach(function (uid) {
        modifiedForData.forEach(function (row) {
            if (row.uid === uid) {
                filteredModifed[tableUids[uid]] = __assign(__assign({}, initialFormData[0]), row);
            }
        });
    });
    filteredModifed = filteredModifed.filter(function (row) { return row; });
    for (var i = 0; i < filteredModifed.length; i++) {
        if (filteredModifed[i].uid.indexOf(Tables_1.RowPrefix.Dynamic) > -1)
            continue;
        filteredModifed[i].rowId++;
    }
    var _loop_1 = function (i) {
        Object.keys(columns).forEach(function (columnName) {
            modifiedForData[i].actions = updateActionsRowId(createDefaultTableAction(component, i, columnName, tab, tableUids), i);
        });
    };
    for (var i = 0; i < modifiedForData.length; i++) {
        _loop_1(i);
    }
    return overrideTableDefaultsWithChanges(rowChanged, filteredModifed, tableUids);
}
exports.overrideDefaultsAndFilterRows = overrideDefaultsAndFilterRows;
function createTableUids(component, tab, model, tableState) {
    var _a, _b, _c;
    var table = component;
    var dynamicTableData = model === null || model === void 0 ? void 0 : model.getDerivedFunction(component.name, component, model, tab);
    if (dynamicTableData) {
        var uidMap_1 = {};
        var rowNum_1 = 0;
        dynamicTableData.forEach(function (entry) {
            var uid = entry === null || entry === void 0 ? void 0 : entry.uid;
            if (uid !== undefined) {
                uidMap_1[uid] = rowNum_1++;
            }
        });
        return uidMap_1;
    }
    var rowData = table["rowData"];
    if (!dynamicTableData && rowData) {
        var _loop_2 = function (i) {
            if (!rowData[i].uid) {
                rowData[i].uid = createRowUid(Tables_1.RowPrefix.Default, i);
            }
            rowData[i].rowId =
                (_b = (_a = (0, Arrays_1.find)(tableState !== null && tableState !== void 0 ? tableState : [], function (row) { return row.uid === (rowData === null || rowData === void 0 ? void 0 : rowData[i].uid); })) === null || _a === void 0 ? void 0 : _a.rowId) !== null && _b !== void 0 ? _b : rowData[i].rowId;
        };
        for (var i = 0; i < rowData.length; i++) {
            _loop_2(i);
        }
    }
    else {
        rowData =
            dynamicTableData !== null && dynamicTableData !== void 0 ? dynamicTableData : createInitialRows(table).map(function (row) {
                var _a, _b;
                return __assign(__assign({}, (row !== null && row !== void 0 ? row : {})), { rowId: (_b = (_a = (0, Arrays_1.find)(tableState !== null && tableState !== void 0 ? tableState : [], function (r) { return r.uid === (row === null || row === void 0 ? void 0 : row.uid); })) === null || _a === void 0 ? void 0 : _a.rowId) !== null && _b !== void 0 ? _b : row.rowId });
            });
    }
    var uidMapBuilder = (_c = model === null || model === void 0 ? void 0 : model.getTableHelpers().createUidMapBuilder()) !== null && _c !== void 0 ? _c : (0, exports.getTableHelpers)().createUidMapBuilder();
    return uidMapBuilder
        .addDefaultRows(rowData)
        .addDynamicRows(tableState !== null && tableState !== void 0 ? tableState : [])
        .removeRows(tableState !== null && tableState !== void 0 ? tableState : [])
        .sortByValue()
        .create();
}
exports.createTableUids = createTableUids;
function getCellValidationInfo(component) {
    var table = component;
    var colInfo = [];
    var columns = table.columns;
    for (var column in columns) {
        var colData = table.columns[column];
        if (colData === null || colData === void 0 ? void 0 : colData["cellValidator"]) {
            colInfo.push({
                type: colData["type"],
                minValue: colData["cellValidator"]["minValue"],
                maxValue: colData["cellValidator"]["maxValue"],
                errMessage: colData["cellValidator"]["errorMessage"],
                errTitle: colData["cellValidator"]["errorTitle"],
                cValidation: colData["cellValidator"]["cValidation"],
                cValidationErrTitle: colData["cellValidator"]["cValidationErrorTitle"],
                cValidationErrMessage: colData["cellValidator"]["cValidationErrorMessage"],
            });
        }
    }
    return colInfo;
}
exports.getCellValidationInfo = getCellValidationInfo;
function getTableActions(component, tab, model, uids, rowFormData) {
    var _a, _b, _c, _d, _e;
    var table = component;
    var dynamicTableData;
    if (!rowFormData) {
        dynamicTableData = model === null || model === void 0 ? void 0 : model.getDerivedFunction(component.name, component, model, tab);
    }
    var rowData = (_b = (_a = rowFormData !== null && rowFormData !== void 0 ? rowFormData : dynamicTableData) !== null && _a !== void 0 ? _a : table["rowData"]) !== null && _b !== void 0 ? _b : createInitialRows(table);
    var columnNames = Object.keys(table.columns);
    var tableActions = { table: {} };
    var rowCount = 0;
    var tableState = (_e = (_d = (_c = model === null || model === void 0 ? void 0 : model.getState()) === null || _c === void 0 ? void 0 : _c[tab]) === null || _d === void 0 ? void 0 : _d[component.group]) === null || _e === void 0 ? void 0 : _e[component.name];
    rowData.forEach(function (row) {
        columnNames.forEach(function (columnName) {
            var _a, _b, _c, _d;
            if (!tableActions["table"][row.uid]) {
                tableActions["table"][row.uid] = {};
            }
            var uid;
            for (var uidsKey in uids) {
                if (uids[uidsKey] === row.rowId) {
                    uid = uidsKey;
                }
            }
            uid = uid !== null && uid !== void 0 ? uid : createRowUid(Tables_1.RowPrefix.Default, rowCount);
            var defaultAction = createDefaultTableAction(component, rowCount, columnName, tab, uid);
            if (tableState) {
                var ind_1 = -1;
                var filtered = tableState.filter(function (row, index) {
                    ind_1 = index;
                    return row.uid === uid;
                });
                if (filtered.length) {
                    defaultAction = createDefaultTableAction(component, ind_1, columnName, tab, uid !== null && uid !== void 0 ? uid : createRowUid(Tables_1.RowPrefix.Default, rowCount));
                }
            }
            if (component.columns[columnName].type == "ComboBox") {
                defaultAction["payload"] = __assign(__assign({}, defaultAction["payload"]), { options: getComboOptions((_a = model === null || model === void 0 ? void 0 : model.getDerivedFunctions()) === null || _a === void 0 ? void 0 : _a.overrideTableOptions, table.columns[columnName], columnName, component.name) });
            }
            var cellAction = (_c = (_b = row.actions) === null || _b === void 0 ? void 0 : _b[columnName]) !== null && _c !== void 0 ? _c : defaultAction;
            tableActions["table"][row.uid][columnName] =
                (_d = model === null || model === void 0 ? void 0 : model.getDerivedFunction("getActions", table.name, cellAction)) !== null && _d !== void 0 ? _d : cellAction;
        });
        rowCount++;
    });
    var uidKeys = Object.keys(uids);
    uidKeys.forEach(function (uidKey) {
        columnNames.forEach(function (columnName) {
            if (uids[uidKey] > -1) {
                if (!tableActions["table"][uidKey]) {
                    tableActions["table"][uidKey] = {};
                    tableActions["table"][uidKey][columnName] = createDefaultTableAction(table, uids[uidKey], columnName, tab, uidKey);
                }
                else if (!tableActions["table"][uidKey][columnName]) {
                    tableActions["table"][uidKey][columnName] = createDefaultTableAction(table, uids[uidKey], columnName, tab, uidKey);
                }
            }
        });
    });
    return JSON.stringify(tableActions);
}
exports.getTableActions = getTableActions;
function getTableUiSchema(table, columns) {
    var _a, _b;
    var tableUi = {
        tableCols: columns,
        search: table["isSearchable"],
        striped: true,
        bordered: false,
    };
    if (table["canRemoveRows"]) {
        tableUi = __assign(__assign({}, tableUi), { rightActions: getTableRightActions() });
    }
    if (table["canInsertRows"]) {
        tableUi = __assign(__assign({}, tableUi), { leftActions: getTableLeftActions() });
    }
    if (table.canMoveRowDown) {
        tableUi = __assign(__assign({}, tableUi), { leftActions: ((_a = tableUi.leftActions) !== null && _a !== void 0 ? _a : []).concat(getTableMoveRowActions()[0]) });
    }
    if (table.canMoveRowUp) {
        tableUi = __assign(__assign({}, tableUi), { leftActions: ((_b = tableUi.leftActions) !== null && _b !== void 0 ? _b : []).concat(getTableMoveRowActions()[1]) });
    }
    return {
        "ui:field": "table",
        className: "col-md-12 individualComponent",
        table: __assign({}, tableUi),
    };
}
exports.getTableUiSchema = getTableUiSchema;
function getCellStyle(isReadonly) {
    var tdStyle = {
        overflow: "hidden",
        textOverflow: "ellipsis",
    };
    if (isReadonly) {
        tdStyle["backgroundColor"] = "#EEEEEE";
    }
    return tdStyle;
}
exports.getCellStyle = getCellStyle;
function getHeaderStyle(maxHeaderSize, displayHeadersDiagonally) {
    return displayHeadersDiagonally
        ? getDiagonalHeaderStyles(maxHeaderSize)
        : getDefaultHeaderStyles(maxHeaderSize);
}
exports.getHeaderStyle = getHeaderStyle;
function getDiagonalHeaderStyles(maxHeaderSize) {
    var headerSizeMultiplier = 3.3;
    return {
        position: "relative",
        bottom: "-7px",
        left: "6px",
        transformOrigin: "bottom left",
        transform: "rotate(-30deg)",
        paddingTop: "".concat(headerSizeMultiplier * maxHeaderSize, "px"),
    };
}
function getDefaultHeaderStyles(maxHeaderSize) {
    return {
        whiteSpace: "unset",
        maxWidth: "".concat(maxHeaderSize, "px"),
    };
}
function createDefaultTableAction(component, row, column, tab, uid) {
    return {
        type: "[Table] EDIT_CELL",
        payload: {
            tabId: tab !== null && tab !== void 0 ? tab : "main",
            path: "".concat(component === null || component === void 0 ? void 0 : component.group, ".").concat(component === null || component === void 0 ? void 0 : component.name),
            column: column,
            value: "%v",
            uid: uid,
            rowId: row,
        },
    };
}
function updateActionsRowId(currentActions, rowId) {
    var modifiedActions = __assign({}, currentActions);
    var columnNames = Object.keys(currentActions);
    columnNames.forEach(function (columnName) {
        var _a;
        var payload = (_a = modifiedActions[columnName]) === null || _a === void 0 ? void 0 : _a["payload"];
        if (payload) {
            var path = payload["path"].split(".");
            path[path.length - 2] = rowId;
            modifiedActions[columnName]["payload"]["rowId"] = rowId;
            modifiedActions[columnName]["payload"]["path"] = path.join(".");
        }
    });
    return modifiedActions;
}
var getDefaultValue = function (overrideDefaultValues, component, componentName, tableName) {
    var _a;
    return ((_a = overrideDefaultValues === null || overrideDefaultValues === void 0 ? void 0 : overrideDefaultValues(tableName, componentName)) !== null && _a !== void 0 ? _a : (component.type === "ComboBox"
        ? component.defaultValue.value
        : component.defaultValue));
};
var getComboOptions = function (overrideOptions, component, componentName, tableName) {
    var _a;
    var dynamicOptions = overrideOptions === null || overrideOptions === void 0 ? void 0 : overrideOptions(tableName, componentName);
    return dynamicOptions && dynamicOptions.length > 0
        ? dynamicOptions
        : (_a = component === null || component === void 0 ? void 0 : component.defaultValue) === null || _a === void 0 ? void 0 : _a["options"];
};
function getTableLeftActions() {
    return [
        {
            dataField: "insert-button",
            editable: false,
            displayName: "",
            columnWidth: "21px",
            width: "21px",
            tdStyle: { textOverflow: "unset" },
        },
    ];
}
function getTableRightActions() {
    return [
        {
            dataField: "delete-button",
            editable: false,
            displayName: "",
            columnWidth: "21px",
            width: "21px",
            tdStyle: { textOverflow: "unset" },
        },
    ];
}
function getTableMoveRowActions() {
    return [
        {
            dataField: "row-down-button",
            editable: false,
            displayName: "",
            columnWidth: "21px",
            width: "21px",
        },
        {
            dataField: "row-up-button",
            editable: false,
            displayName: "",
            columnWidth: "21px",
            width: "21px",
        },
    ];
}
function createRowUid(prefix, postfix) {
    return prefix + postfix;
}
//# sourceMappingURL=tables.js.map